/*
* @Author: tengmaoqing
* @Date:   2018-04-13 16:24:43
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-26 11:35:01
*/
import getAppInitParams from './main';
import initClientApp from '@/system/init/init-client-app';
import { setIfrHeight } from '@/helper/iframeEvent';
import { throttle } from 'lodash';
import TKDMixin from '@/helper/TKD';

const throttledSet = throttle(setIfrHeight, 500);
document.body.addEventListener('click', () => {
  setTimeout(throttledSet, 400);
});
const vueInstance = initClientApp(getAppInitParams(), {
  pageLoaded (app, store, router) {
    TKDMixin(app, router.currentRoute, store);
    setTimeout(() => {
      throttledSet();
    }, 500);
  }
});
// console.log('vue实例：', vueInstance);
try {
  /* eslint-disable no-undef */
  ReportPoint.joinApp({
    interfaceApp: vueInstance.vueApp,
    frameName: 'VueApp'
  });
} catch (err) {}



// WEBPACK FOOTER //
// ./src/projects/hsbpc/entry-client.js